export function initializeAndAddFacebookSDK() {
  window.fbAsyncInit = function () {
    window.FB.init({
      appId: process.env.GATSBY_APP_FB_ID ?? '',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v22.0',
    });
  };

  const script = document.createElement('script');

  script.async = true;
  script.defer = true;
  script.crossOrigin = 'anonymous';
  script.src = 'https://connect.facebook.net/en_US/sdk.js';

  document.body.insertBefore(script, document.body.firstChild);
}
